import { Sparkles } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { INSTALL_COMMANDS, IMPORT_SNIPPETS } from '@/constants/integration';
import { Reveal } from './Reveal';
import { STANDOUT } from './content';

export function Standout() {
  return (
    <section className="border-b border-hairline py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center sm:mb-14">
          <Badge variant="outline" className="mb-4">
            <Sparkles className="size-3" />
            Why teams choose Aicostr
          </Badge>
          <h2 className="text-balance text-3xl font-semibold tracking-tight sm:text-4xl">
            Drop it in — without touching your AI code.
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-balance text-base text-muted-foreground">
            No proxy, no shared keys, no per-call changes. One import and every
            OpenAI, Anthropic, and Gemini call is tracked.
          </p>
        </div>

        {/* One-line install snippet — Python and Node are both first-class */}
        <Reveal className="mx-auto mb-10 max-w-2xl">
          <div className="glass-card overflow-x-auto rounded-xl p-5 font-mono text-sm leading-relaxed">
            <p className="text-muted-foreground"># Python</p>
            <p className="text-foreground">{INSTALL_COMMANDS.python}</p>
            <p className="text-foreground">{IMPORT_SNIPPETS.python}</p>
            <p className="mt-4 text-muted-foreground"># Node.js</p>
            <p className="text-foreground">{INSTALL_COMMANDS.node}</p>
            <p className="whitespace-pre text-foreground">
              {IMPORT_SNIPPETS.node}
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STANDOUT.map(({ icon: Icon, title, copy }, i) => (
            <Reveal key={title} delay={i * 0.08} className="h-full">
              <div className="glass-card h-full space-y-3 rounded-xl p-6 transition-colors duration-150 ease-out-quart hover:border-border">
                <span className="grid size-9 place-items-center rounded-lg bg-primary/10 text-primary ring-1 ring-primary/20">
                  <Icon className="size-4" />
                </span>
                <div className="space-y-1">
                  <h3 className="text-sm font-semibold tracking-tight">
                    {title}
                  </h3>
                  <p className="text-sm text-muted-foreground">{copy}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
